export default "__VITE_ASSET__C3t3l9$m__"